import React, { Component } from "react";
import classNames from "classnames";
// import PropTypes from "prop-types";
import LobbyView from "../host/LobbyView";
import ReadingDisplay from "../host/ReadingDisplay";
import Scoreboard from "../host/Scoreboard";
import ControlButtons from "../host/ControlButtons";
import Timer from "../Timer";
import PlayerList from "../host/PlayerList";
import Options from "../host/Options";
import OptionsHUD from "../host/OptionsHUD";
import Volume from "../Volume";

import createSocketClient from "../../shared/createSocketClient";
import {
  sharedOnMountInit,
  sharedInitialState,
} from "../../shared/sharedViewInit";

import audio from "../../audio/audio";

import C from "../../constants";
const {
  STATE_MACHINE: { STATES },
} = C;

export default class HostView extends Component {
  state = {
    ...sharedInitialState(this.props),
    socket: createSocketClient(),

    players: [],
    adminKey: localStorage.getItem(`${this.props.match.params.code}_adminKey`),

    optionSets: [],
    customSetData: {},

    yetToAnswer: [],

    filledPrompt: {},
    currentVotingResults: {},
    votingIsComplete: false,

    scoringDetails: {}, // For each vote
    scoreboardData: [], // For end of round/game
    debugDisplay: false,
  };

  joinRoomAsAdmin = (roomCode, adminKey) => {
    this.state.socket.emit("joinroomasadmin", {
      roomCode: roomCode,
      adminKey: adminKey,
    });
  };

  joinThisRoomAsAdmin = () => {
    this.joinRoomAsAdmin(this.state.roomCode, this.state.adminKey);
  };

  getPlayerInfoById = (playerId) => {
    return this.state.players.find((player) => {
      return player.playerId === playerId;
    });
  };

  kickPlayer = (playerId) => {
    this.state.socket.emit("kickplayer", {
      playerId,
    });
  };

  loadCustomPromptSet = (code) => {
    this.state.socket.emit("loadcustomset", {
      code: code,
    });
  };

  unloadCustomPromptSet = () => {
    this.state.socket.emit("unloadcustomset");
  };

  updateOptionSet = (name) => {
    this.state.socket.emit("updateOptions", {
      name,
    });
  };

  componentDidMount() {
    sharedOnMountInit(this);
    // this.state.socket.on("connection", () => console.log("Connected!"));

    this.state.socket.on("players", (data) => {
      console.log("Players", data);
      if (data.players.length > this.state.players.length) {
        // New player
        audio.playCheck(this.state.volume);
      }
      this.setState({ players: data.players });
    });

    this.state.socket.on("adminkeyerror", (data) => {
      console.log("Admin Key Error");
    });

    this.state.socket.on("yettoanswer", (data) => {
      this.setState({ yetToAnswer: data.yetToAnswer });
    });

    this.state.socket.on("nextfilledprompt", (data) => {
      console.log("Filled Prompt:", data);
      this.setState({
        votingIsComplete: false,
        filledPrompt: data.prompt,
        currentVotingResults: {},
      });
    });

    this.state.socket.on("votingresults", (data) => {
      console.log("Voting Results", data);
      this.setState({
        currentVotingResults: data.votingResults,
        votingIsComplete: true,
        scoringDetails: data.scoringDetails,
      });
    });

    this.state.socket.on("scoreboarddata", (data) => {
      audio.playWow(this.state.volume);
      this.setState({ scoreboardData: data.scoreboardData });
    });

    this.state.socket.on("custompromptstatus", (data) => {
      console.log("Custom Prompt Status", data);
      this.setState({
        customSetData: data,
      });
    });

    this.state.socket.on("optionsets", (optionSets) => {
      this.setState({
        optionSets,
      });
    });

    this.joinThisRoomAsAdmin();
  }

  componentWillUnmount() {
    this.clearTimer();
    this.state.socket.removeAllListeners();
  }

  render() {
    return (
      <div
        className={classNames("fun-bg", this.state.theme.backgroundClasses)}
        style={this.state.theme.backgroundStyles}
      >
        <div
          className="host-view"
          style={{ color: this.state.theme.textColor }}
        >
          {/* Admin Header */}
          <div className="host-header">
            <div className="inline-flex push-left">
              <div className="game-panel">
                <div className="is-size-5">
                  <p>
                    <span className="tag is-warning is-large has-text-weight-bold is-size-4">
                      {this.state.roomCode}
                    </span>{" "}
                    join at {window.location.host}
                  </p>
                </div>
              </div>
              <div className="game-panel flex-center-text">
                <Volume
                  muted={this.state.volume === 0}
                  toggleMute={this.toggleMute}
                ></Volume>
              </div>
              <OptionsHUD
                options={this.state.gameOptions}
                currentRoundIndex={this.state.currentRoundIndex}
                currentState={this.state.currentState}
              ></OptionsHUD>
            </div>
            {/* Right */}
            <div className="inline-flex">
              <ControlButtons
                startable={this.state.players.length >= 3}
                currentState={this.state.currentState}
                socket={this.state.socket}
              ></ControlButtons>
            </div>
          </div>
          {/* Debug View */}
          {this.state.debugDisplay && (
            <div className="game-panel level host-footer">
              <div className="level-left">
                <span className="level-item tag is-success is-medium">
                  Admin
                </span>
                <span className="level-item tag is-warning is-medium">
                  Debug View
                </span>
                <div className="level-item">
                  state={this.state.currentState}
                </div>
                <div className="level-item">
                  bg-pattern={this.state.theme.backgroundClasses}
                </div>
              </div>
            </div>
          )}
          {/* Timer */}
          {this.state.timerIsVisible && (
            <div className="host-footer">
              <Timer
                msRemaining={this.state.msRemaining}
                msTotal={this.state.msTotal}
                label={this.state.currentState}
                showLabel="true"
              ></Timer>
            </div>
          )}
          {/* Lobby View */}
          {this.state.currentState === STATES.LOBBY && (
            <>
              <div className="host-top-main">
                <LobbyView roomCode={this.state.roomCode}></LobbyView>
                <PlayerList
                  title={`${this.state.players.length}/${this.state.gameOptions.maxPlayers} players have joined`}
                  players={this.state.players}
                  kickable={true} // In lobby
                  kickfn={this.kickPlayer}
                ></PlayerList>
              </div>
              <div className="host-lower">
                <Options
                  playerCount={this.state.players.length}
                  loadCustomPromptSet={this.loadCustomPromptSet}
                  unloadCustomPromptSet={this.unloadCustomPromptSet}
                  loadedCustomSetData={this.state.customSetData}
                  currentOptionSet={this.state.gameOptions}
                  optionSets={this.state.optionSets}
                  updateOptionSet={this.updateOptionSet}
                ></Options>
              </div>
            </>
          )}

          {this.state.currentState === STATES.PROMPTS && (
            <>
              <div className="host-main">
                <PlayerList
                  title="Waiting on these players to answer their prompts!"
                  extraCssClasses="ld ld-shake-v"
                  players={this.state.players.filter((player) => {
                    return this.state.yetToAnswer.includes(player.playerId);
                  })}
                ></PlayerList>
              </div>
              <div className="host-lower game-panel">
                <h1 className="has-text-centered is-size-2">
                  Answer prompts on your devices now!
                </h1>
              </div>
            </>
          )}
          {(this.state.currentState === STATES.VOTING ||
            this.state.currentState === STATES.SCORING) &&
            this.state.filledPrompt && (
              <div className="host-main">
                <ReadingDisplay
                  prompt={this.state.filledPrompt}
                  votingResults={this.state.currentVotingResults}
                  scoringDetails={this.state.scoringDetails}
                  votingIsComplete={this.state.votingIsComplete}
                  getPlayerInfoById={this.getPlayerInfoById}
                ></ReadingDisplay>
              </div>
            )}
          {(this.state.currentState === STATES.END_OF_ROUND ||
            this.state.currentState === STATES.FINAL_SCORES) && (
            <div className="host-main">
              <Scoreboard data={this.state.scoreboardData}></Scoreboard>
            </div>
          )}
        </div>
      </div>
    );
  }
}
